import { AfterViewInit, Component, HostListener, OnInit, OnDestroy, ViewEncapsulation, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormValidationComponent } from '../form-validation/form-validation.component';
import { EmitterService } from '../services/emitter.service';
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { UserDetailsService } from '../services/user-details.service';
import { CustomValidators } from '../shared/utility/custom-validator';
import { Utility } from '../shared/utility/utility';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { language, txnState } from '../shared/utility/config';
import { BonusService } from '../app-myaccount/bonuses/services/bonus.service';
import { CountryDataService } from '../services/country.service';
import { PoliciesVersionService } from '../services/policies-version.service';
import { CreateAccountPnpComponent } from '../create-account-pnp/create-account-pnp.component';
import { AppDetailsService } from '../services/app-details.services';
import { Router } from '@angular/router';
import { AjaxService } from '../services/ajax.service';


@Component({
  selector: 'app-deposit-popup',
  templateUrl: './app-deposit-popup.component.html',
  styleUrls: ['./app-deposit-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class AppDepositPopupComponent extends FormValidationComponent implements OnInit, AfterViewInit, OnDestroy {
  isUserLoggedIn: boolean;
  isThirdPartyLoginCalled: boolean;
  isCurrencyDefaultPosition = true;
  termsAndCondtionsInfo;
  @ViewChild('inpuRef', { static: false }) inpuRef: any;
  @HostListener('window:message', ['$event']) onMessage(e) {
    if (e && e.data && e.data.message === 'deposit-transactionStatus') {
      this.paymentProcessStep = 'step3';
      this.getPNPUserFromTransaction();
    }
    if(e && e.data && e.data.message === 'withdraw-transactionStatus'){
      this.paymentProcessStep='step3';
     this.getWithdrawTransactionStatus();
    }
  }

  windowType: string;
  transactionId
  callingFrom: string;
  transactionErrorMessage: any;
  transactionSuccessMessage: string;
  paymentProcessStep: string = 'step1';
  currencySymbol: any = this.userDetailsService.getZimplerDefaultCurrencySybmol();
  predefineAmounts = ['50','250','500']
  depositAmount: any = this.predefineAmounts[1];
  langCode: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  transactionType: any;
  isButtonLoader: boolean = false
  userProfileDetails;
  isToTriggerS2SForThirdPartyLogin = false;
  s2sTxnAmount = 0;
  isPercentageWithdrawFee = false;
  isPercentageWithdrawFeeValue = 0;
  isStepThree = false;
  quickRegistereCalled = false;
  withdrawalBalance=0;
  feesInfo = {
    maxFee:0,
    minFee:0,
    fee:0,
    isPercentage:false,
    feeType:""
   };
   userInfo;
   countryIP;
  transactionFee = 0;
  transactionFeeType:any;
  isLoadingBrite;
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaPath = environment.mediaPath;
  userCurrencySymbol ='';
  valueOne = '50';
  valueTwo = '250';
  valueThree = '500';
  multipleValue = 1;
  isSemiPnp;
  isPnpFlow;
  isZimplerPnp;
  isNorway = false;
  requestLoopCount = 0;
  requestCountForNewUser=0;
  userCheckRequestCount=0;
  cashierBannerZoneid = environment.pnpCashierBannerZoneId;
  cancellBriteFrame = false;
  @ViewChild(CreateAccountPnpComponent) createPnpUser:CreateAccountPnpComponent;
  constructor(
    private formBuilder: FormBuilder,
    private customValidators: CustomValidators,
    public utils: Utility,
    private emitterService: EmitterService,
    private userDetailsService: UserDetailsService,
    private pnpService: PnpZimplerService,
    private translationService: TranslateService,
    private bonusService: BonusService,
    private countryDataService: CountryDataService,
    private polociesService:PoliciesVersionService,
    private ajaxService:AjaxService,
    private cdrf:ChangeDetectorRef

  ) {
    super(utils);
    this.termsAndCondtionsInfo =  this.translationService.instant("quickDeposit.termsAndConditionsInfo");
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.pnpService.initiateLogin$.pipe(takeUntil(this.destroy$)).subscribe(txnType => {
      if (txnType === "LOGIN") {
        this.transactionType = "LOGIN_DEPOSIT"
        this.paymentProcessStep = 'step2'
        this.zimplerPNPInit(txnType);
      }
    });

    this.pnpService.initiateDespoit$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data && ['deposit'].indexOf(data['callingFrom']) > -1) {
        this.isUserLoggedIn = this.utils.isUserLoggedIn();
        this.callingFrom = 'deposit';
        this.transactionType = "REG_DEPOSIT"
        this.clearIframeData();
        this.paymentProcessStep = 'step1';
        this.updateLimits();
      }
    })

    this.pnpService.initiateWithDraw$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data && ['withdraw'].indexOf(data['callingFrom']) > -1) {
        this.callingFrom='withdraw';
        this.clearIframeData();
        this.paymentProcessStep='step1';
        this.updateLimits();
      }
    })

    //quick deposit initiation for Finland users
    this.pnpService.initQuickDeposit$.pipe(takeUntil(this.destroy$)).subscribe((data) => {
        if(data && data['amount']) {
          this.setTransactionAmount(data['amount']);
          if(environment.semiPnpZimplerCountries.indexOf(this.countryDataService.IPCountry) >= 0){
            this.paymentProcessStep = 'semiPnpFlow'
          }else{
            this.paymentProcessStep = 'step2'
            this.zimplerPNPInit();
          }
          
        }
    });

    this.langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en'
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.emitterService.updateUserCountry$.pipe(takeUntil(this.destroy$)).subscribe(country => {
      this.countryIP = country;
    });

    this.emitterService.emitWithdrawlFeesDetails$.pipe(takeUntil(this.destroy$)).subscribe((status)=>{
      this.setWithdrawlFee();
    });
    
    this.userDetailsService.userProfileUpdated$.pipe(takeUntil(this.destroy$)).subscribe(userData => {
      this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
      if(this.userProfileDetails && this.isToTriggerS2SForThirdPartyLogin){
        this.utils.S2Scalls(this.userProfileDetails, "deposit", this.s2sTxnAmount);
      }
      this.paymentProcessStep = 'step4';
      this.s2sTxnAmount = 0;
      this.isToTriggerS2SForThirdPartyLogin = false;
      if(!this.isStepThree){
     
      this.emitterService.broadcasttxnComplete("SUCCESS");
        this.navigateAfterLogin();
      }
    })

    if(this.isUserLoggedIn){
      this.isCurrencyDefaultPosition = this.userDetailsService.userCurrencyInfo?.position == 'after' ? false : true;
    }
    
  
  }
  @ViewChild('hiddenText') textEl: ElementRef;

  width;
  currentKeyCode;
  updateKeyCode(event){
   this.currentKeyCode = event.keyCode;
  } 
  checkMaxValue(e){
    let value = $('#inputAmount')[0].innerText
    if(value.indexOf('.') == 0 || value.indexOf('0') == 0){
      $('#inputAmount')[0].innerText = this.depositAmount
      return
    }
    
    if(typeof value == 'string'){
      value = parseFloat(value);
      this.depositAmount = value;
    }else{
      this.depositAmount = value;
    }
    if (value >= 15000 && !this.isNorway || this.isNorway && value >= 150000) {
      if (!this.isNorway) {
        value = "15000";
      } else {
        value = "150000";
      }
      this.depositAmount = value;
      $('#inputAmount')[0].innerText = this.depositAmount;
      this.setCaretToEnd(e.target);
    } 
    if(this.callingFrom == 'withdraw'){
      this.setWithdrawlFee();
      this.setCaretToEnd(e.target);
   }
  }

  showCaret(event: FocusEvent) {
    event.preventDefault();  
    event.stopPropagation();
    // This function can be used to show the caret when the user focuses on the input field
    const inputElement = event.target as HTMLElement;
    inputElement.style.caretColor = 'black'; // or any color you prefer
}
  resetValue(){
    if(!this.depositAmount){
      this.depositAmount = this.getValueForTab(this.valueTwo);
      return
    }
    this.depositAmount = parseFloat(this.depositAmount);
    $('#inputAmount')[0].innerText = this.depositAmount;
  }
 
  setCaretToEnd(event) {
   this.utils.setCaretToEnd(event)
  }
  customAmountSet(event,value){
    this.depositAmount = value;
    this.setWithdrawlFee();
    $('#inputAmount')[0].innerText = this.depositAmount;
    this.setCaretToEnd(event);
  }
  
  ngOnInit() {
    this.getPNPMinMaxTxnLimits();
    this.getWindowType();
    this.s2sTxnAmount = 0;
    this.isToTriggerS2SForThirdPartyLogin = false;
    this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
    this.userInfo = this.isUserLoggedIn ? this.userDetailsService.getUserProfileDetails() : null;
    this.countryIP = this.userInfo && this.userInfo['country'] ? this.userInfo['country'] :this.countryDataService.IPCountry ? this.countryDataService.IPCountry.toUpperCase() : "";
    if(!this.countryIP){
      this.countryIP = this.countryDataService.IPCountry
    }
    if(this.countryIP){
      this.isStepThree = (environment.semiPnpZimplerCountries.indexOf(this.countryIP) != -1 && !this.isUserLoggedIn) ? true : false;
    }
    this.isPnpFlow = environment.zimplerCountries.indexOf(this.countryIP)>=0 ? true : false;
    this.isSemiPnp = environment.semiPnpZimplerCountries.indexOf(this.countryIP)>=0 ? true : false;
    this.isZimplerPnp = !this.isPnpFlow && environment.zimplerPnp.indexOf(this.countryIP)>=0 ? true : false; 
    this.emitterService.showLoginFailiedZimpler$.subscribe((status:any) => {
      if(status == "LOGIN_FAILED"){
        this.callingFrom = 'login';
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.login_without_depositFailureMsg');
      }else if(status == "TRANSACTION_CANCELLED"){
        this.callingFrom = 'deposit';
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong');
      }      
    });
  }

  ngAfterViewInit() {
    this.utils.openModal('pnpDepositModal');
    if(this.inpuRef && this.inpuRef.nativeElement){
      this.customAmountSet(this.inpuRef.nativeElement, this.valueTwo);
    }
    if(this.utils.isMobileDepositModal){
      this.paymentProcessStep = 'step3';
      this.callingFrom = 'deposit';
      this.utils.isMobileDepositModal = false;
    }
    /*GTM event for user starts pnp registration on initial page PNP page load*/
    if(!this.utils.isUserLoggedIn() && (this.transactionType !== "LOGIN_DEPOSIT")) {
      this.utils.gtmEvent("registerStart", {
        evntType: "registerStart"
      });
    }
     setTimeout(()=>{  
      let focusInput = document.getElementById("inputAmount");
      if(focusInput && this.windowType == 'device'){
        const element:any = document.getElementById('pnp-modal-body-content');
        focusInput.focus();
        if(element)
          element.scrollTop = 0;
      }
     },1000);
     this.cdrf.detectChanges();
  }

  openStepTwo(){
    if(this.isStepThree && !this.isUserLoggedIn){
      this.paymentProcessStep = 'semiPnpFlow';
    }else{
      this.zimplerPNPInit();
    }
  }
  registerCheck(){
    this.paymentProcessStep = 'step2';
    this.isStepThree = false;
    this.zimplerPNPInit();
  }
  registerUser(){
    this.createPnpUser.registerUser();
  }
  setWithdrawlFee() {
    let feesInfo = this.pnpService.getWithdrawlFeeDetails();
    this.setWithdrwalFeeAmount(feesInfo);
  }
 async setWithdrwalFeeAmount(feeInfoData){
    this.feesInfo = feeInfoData;
    let traFee = 0.0;
    traFee = await this.checkLimits();
    if(this.feesInfo && this.feesInfo.isPercentage){
      this.isPercentageWithdrawFee = true;
      this.isPercentageWithdrawFeeValue = traFee;
      this.updateWithdrawAmountWithPercentageFee(this.isPercentageWithdrawFeeValue);
    }else{
      this.transactionFee = traFee;
      this.isPercentageWithdrawFee = false;
    }
  }
  async checkLimits(){
    let traFee = 0.0;
    if(this.feesInfo && this.feesInfo.fee && !this.feesInfo.maxFee && !this.feesInfo.minFee){
      traFee = this.feesInfo.fee;
   }else if(this.feesInfo && this.feesInfo.fee && (this.feesInfo.minFee && this.feesInfo.maxFee || !this.feesInfo.minFee && this.feesInfo.maxFee)){
     if(this.feesInfo.fee > this.feesInfo.maxFee){
        if(this.feesInfo.isPercentage){
         traFee = this.feesInfo.fee;
        }else{
         traFee = this.feesInfo.maxFee;
        }
     }else if(this.feesInfo.fee < this.feesInfo.minFee){
       if(this.feesInfo.isPercentage){
         traFee = this.feesInfo.fee;
        }else{
         traFee = this.feesInfo.minFee;
        }
     }else{
       traFee = this.feesInfo.fee;
     }
   }
    return traFee;
  }
  percentage(percent, total):any {
    let percentage:any =  ((parseFloat(percent)/ 100) * parseFloat(total)).toFixed(2);
    if(this.feesInfo.maxFee >= percentage && this.feesInfo.minFee <= percentage){
      return percentage;
    }else if(this.feesInfo.maxFee < percentage){
      return this.feesInfo.maxFee;
    }else if(this.feesInfo.minFee > percentage){
      this.feesInfo.minFee;
    }
  }
  getTotalAmount(){
    if(this.depositAmount && this.transactionFee){
      return this.depositAmount - this.transactionFee;
    }
    return 0;
  }
  checkForValidTotal(){
    return this.getTotalAmount() >= 1;
  }
  updateWithdrawAmountWithPercentageFee(percentage){
   if(this.isPercentageWithdrawFee){
     this.checkLimits();
     this.transactionFee = this.percentage(percentage, this.depositAmount);
   } 
  }
  

  updateLimits() {
    if (this.callingFrom === 'deposit') {
      this.updateDepositLimits();
    }
    if(this.callingFrom === 'withdraw'){
      this.updateWithdrawLimits();
    }
  }

  

  updateDepositLimits() {
    let depositLimits = this.pnpService.depositLimits;
    if (depositLimits['minLimit'] && depositLimits['maxLimit']) {
      this.applyMinMaxFromValidation(depositLimits['minLimit'], depositLimits['maxLimit'], 'deposit')
    } else {
      this.getPNPMinMaxTxnLimits();
    }
  }

  getWindowType() {
    var ww = document.body.clientWidth;
    if (ww >= 1024) {
      this.windowType = 'device';
    } else {
      this.windowType = 'mobile';
    }
  }

  setTransactionAmount(event) {
    if (event) {
      this.depositAmount = event;
      this.updateWithdrawAmountWithPercentageFee(this.isPercentageWithdrawFeeValue);
    }
  }

  getPNPMinMaxTxnLimits() {
    let userCountry = this.userDetailsService?.userProfileDetails?.countryCode ? this.userDetailsService?.userProfileDetails?.countryCode : this.countryDataService?.IPCountry
    this.isPnpFlow = environment.zimplerCountries.indexOf(userCountry)>=0 ? true : false;
    let minMaxRequestData = {
      option: this.isPnpFlow ? "BRITEPLAY": "ZIMPLER_DIRECT",
      currency: 'EUR'
    }
    this.pnpService.getPNPMinMaxTxnLimits(minMaxRequestData)
      .then(data => {
        if (data) {
          this.applyMinMaxFromValidation(data['minLimit'], data['maxLimit'], 'deposit')
        }
      });
  }

  
  getPNPUserFromTransaction() {
    let transactionData = {
      "txnId": localStorage.getItem("txnId")
    }
    this.pnpService.getPNPUserFromTransaction(transactionData).then(transactionStatuData => {
      this.handleRequestLooping(transactionStatuData);
    });
  }
  async handleRequestLooping(transactionStatuData) {
    let requestCounts = this.isSemiPnp || this.isZimplerPnp ? 5 : 40;
    this.transactionId = localStorage.getItem("txnId");
    if (this.requestLoopCount < requestCounts && transactionStatuData &&
      (transactionStatuData['txnStatus'] === 'KYC_VERIFIED' || transactionStatuData['txnStatus'] === 'LOGIN_SUCCESS' || transactionStatuData['txnStatus'] === 'INIT' && transactionStatuData['status'] != "FAILURE")) {
          // if(transactionStatuData['txnStatus'] === 'KYC_VERIFIED' && transactionStatuData['status'] == "FAILURE" && environment.zimplerCountries.indexOf(this.countryIP)>=0){
          //   await this.callQuickRegisterWithKycInfo();
          //  } 

          if((transactionStatuData['txnStatus'] === 'KYC_VERIFIED' || transactionStatuData['txnStatus'] === 'LOGIN_SUCCESS') && transactionStatuData['status'] == "SUCCESS" && transactionStatuData['externalEcrId'] && !this.isThirdPartyLoginCalled){
            if(!sessionStorage.getItem("user")) {
              this.getPNPThirdPartyLogin(this.transactionId, 'quick-registration', '', '', true, transactionStatuData);
              this.isThirdPartyLoginCalled = true;
            }
          }
        setTimeout(() => {
            this.requestLoopCount++;
            this.getPNPUserFromTransaction();
          }, 3000);       
    } else if((transactionStatuData['txnStatus'] === 'INIT' || transactionStatuData['txnStatus'] === 'LOGIN_WITHOUT_DEPOSIT') && transactionStatuData['status'] == "FAILURE"){
        if(transactionStatuData['errorCode'] == 100159 && !this.isUserLoggedIn ){
          if(this.requestCountForNewUser < 3){
            let self = this;
            setTimeout(() => {
              self.requestCountForNewUser++;
              self.getPNPUserFromTransaction();
            }, 3000);
          }else{
            this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.login_without_depositFailureMsg');
          }
          
        }else{
          this.callingFrom = 'deposit';
          this.depositAmount = 50;
          this.backToCashier();
        }
         
    }else{
      this.requestLoopCount = 0;
      if (transactionStatuData) {
        localStorage.setItem("pnpDepositedAmount", transactionStatuData["amount"]);
        localStorage.setItem("pnpDepositedCurrency", transactionStatuData["currency"]);
        this.navigateBasedOnTxStatus(transactionStatuData);
      }
    }
  }
 async callQuickRegisterWithKycInfo(){
    let userData = localStorage.getItem('registerUserData') ? JSON.parse(localStorage.getItem('registerUserData')) : null;
    let reqRequestData = this.getQuickRegisterRequestData(userData);
    this.pnpService.quickRegisterMode(reqRequestData, this.countryIP).then(data => {
      if (data['status'] === 'SUCCESS') {
        this.quickRegisterResponse = data;
      }
      // this.registerUserEvents(data, userData, reqRequestData);
      this.updateUserEventsAndTriggerThirdPartyLogin(data,userData,reqRequestData);
    })
  }
  callZimplerInit(userData){
    if(userData.ecrId){
      localStorage.setItem('newUserZimpler', userData.ecrId.toString());  
    }
    this.isUserLoggedIn = true;
    this.zimplerPNPInit()
  }
  navigateBasedOnTxStatus(transactionStatuData) {
   let newUserEcrId = localStorage.getItem('newUserZimpler') ? localStorage.getItem('newUserZimpler') : ""; 
    const { status, txnStatus, externalEcrId, errorCode } = transactionStatuData;
    this.callHandlers(status,externalEcrId,transactionStatuData,txnStatus,errorCode,newUserEcrId)
  }
 callHandlers(status,externalEcrId,transactionStatuData,txnStatus,errorCode,newUserEcrId){
  localStorage.removeItem('newUserZimpler');
  if (status === 'SUCCESS') {
    if(externalEcrId == newUserEcrId || (txnStatus == "LOGIN_WITHOUT_DEPOSIT" && status == "SUCCESS")){
      this.successTranctionHanlder(txnStatus, transactionStatuData);
    }else if(!this.userDetailsService.isRealUserAccount() || newUserEcrId){
      this.getPNPThirdPartyLogin(this.transactionId, 'quick-registration', '', '', true, transactionStatuData);
    }else{
      this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong_redirection')
      return;
    } 
  }
  if (status === 'FAILURE' && errorCode === 100159) {
    sessionStorage.setItem("user","");
    this.failureTransactionHanlder(txnStatus, transactionStatuData);
  }
 }
  actionOnTransactionRedirection(status, key, callingFrom?, step = 'step4') {
    setTimeout(() => {
      const message = this.translationService.instant(key);
      if(callingFrom){
        this.switchToNextStep(status, step, message, callingFrom);
      }else {
        this.switchToNextStep(status, step, message);
      }
    },1000);
    
  }

  successTranctionHanlder(txnStatus, transactionStatuData) {

    this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
    switch (txnStatus) {
      case 'DEPOSIT_SUCCESS':
      case 'CASHIER_TRANSFER_SUCCESS':
        this.pnpRegisterEvents(transactionStatuData)
        if (!sessionStorage.getItem("user")) {
          this.getPNPThirdPartyLogin(transactionStatuData['txnId'], 'deposit',null,null,null,transactionStatuData);
        } else {
          this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.deposit_success_msg', 'desposit')
        }
        this.emitterService.broadcasttxnComplete("COMPLETED")
        break;
      case 'CASHIER_INIT_DEPOSIT_SUCCESS':
        if (!sessionStorage.getItem("user")) {
          this.getPNPThirdPartyLogin(transactionStatuData['txnId'], 'deposit', true, Number(transactionStatuData["amount"]).toFixed(2));
        } else {
          this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.deposit_success_msg', 'deposit')
          this.pnpRegisterEvents(transactionStatuData)
        }
        break;
      case 'KYC_VERIFIED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.kyc_verified_msg')
        break;
      case 'CASHIER_INIT_DEPOSIT_FAILED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.cashier_init_deposit_failed')
        break;
      case 'LOGIN_WITHOUT_DEPOSIT':
        /**
         * Else condition encounter when user is already logged in with
         * DEMOUSER2 & try to deposit with DEMOUSER4 user
         * In general world on Production we don't encounter this case. 
         */
        if (!sessionStorage.getItem("user")) {
          this.getPNPThirdPartyLogin(transactionStatuData['txnId'], 'login', '', '', false, transactionStatuData);
        } else {
          this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong')
        }
        break;
      case 'CATEGORY_LIMITS_EXCEEDED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.CATEGORY_LIMITS_EXCEEDED')
        break;
      case 'DEPOSIT_NOT_ALLOWED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.deposit_not_allowed')
        break;
      case 'RG_COOL_OFF':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.rg_cool_off')
        break;
    }
   
  }
  pnpRegisterEvents(transactionStatuData){
    this.utils.S2Scalls(this.userProfileDetails, "deposit", Number(transactionStatuData["amount"]).toFixed(2));
    this.utils.depositGTMevent("userDeposited", localStorage.getItem("txnId"), transactionStatuData["externalEcrId"], parseInt(localStorage.getItem("pnpDepositedAmount")), localStorage.getItem("pnpDepositedCurrency"));
    if(!this.userDetailsService.isRealUserAccount()){
      this.utils.S2Scalls(this.userProfileDetails, "pnp");
      this.firstDepositUserEvent(transactionStatuData);
      let userData = localStorage.getItem('registerUserData') ? JSON.parse(localStorage.getItem('registerUserData')) : null;
      this.registerUserEvents(transactionStatuData,userData);
    }
  }
  failureTransactionHanlder(txnStatus, transactionStatuData) {
    switch (txnStatus) {
      case 'LOGIN_WITHOUT_DEPOSIT':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.login_without_depositFailureMsg')
        break;
      case 'DEPOSIT_SUCCESS':
        if(this.userCheckRequestCount){
          return
        }
        if (!sessionStorage.getItem("user")) {
          if (this.utils.getAffliateId('cvalue')) {
            sessionStorage.setItem("pnpUserDeposit", transactionStatuData["amount"]);
            sessionStorage.setItem("pnpUserCurrency", transactionStatuData["currency"] );
          }
          this.userCheckRequestCount=0;
          this.checkPNPUserCreatedOrNot();
        } else {
          this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong')
        }
        break;
      case 'INIT':
      case 'KYC_VERIFIED':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.kyc_verified_msg')
        break; 
    }
  }

   
   checkPNPUserCreatedOrNot() {
    let transactionData = {
      "txnId": localStorage.getItem("txnId")
    }
    this.userCheckRequestCount+=1;
    if(this.userCheckRequestCount <= 10){
      this.pnpService.getPNPUserFromTransaction(transactionData).then(transactionStatuData => {
        if(transactionStatuData['externalEcrId']){
           this.userCheckRequestCount=0;
           transactionStatuData['txnStatus'] = "DEPOSIT_SUCCESS";
           this.successTranctionHanlder('DEPOSIT_SUCCESS', transactionStatuData)
        }else {
         setTimeout(()=>{
          this.checkPNPUserCreatedOrNot();
         },2000)
        }
     });
    }else{
      this.userCheckRequestCount=0;
      this.quickRegisterMode();
    }
  }
  pnpThirdPartyLoginFailHanlder(response, callingFrom) {
    let message = '';
    let key = ''
    switch (callingFrom) {
      case 'login':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.loginFailureMsg')
        break;
      case 'deposit':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.deposit_LoginFailureMsg')
        break;
      case 'quick-registration':
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.quick_registration_LoginFailureMsg')
        break;
      default:
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong')

    }
  }

  switchToNextStep(status, stepNumber, message, callingFrom?) {
    this.userProfileDetails = this.userDetailsService.getUserProfileDetails();
    // failed case
    if (status === 'failure' && message) {
      this.paymentProcessStep = stepNumber;
      this.transactionErrorMessage = message;
      // setTimeout(() => {
      // this.transactionType === "REG_DEPOSIT" ? this.backToCashier() : '';
      // }, 3000)
    }
    // success case
    if (status === 'successful' && message) {
      if(callingFrom) {
          this.paymentProcessStep = stepNumber;
          this.emitterService.broadcasttxnComplete("SUCCESS");
          this.navigateAfterLogin();
      } else {
        this.paymentProcessStep = stepNumber;
        this.transactionSuccessMessage = message;
        this.emitterService.broadcasttxnComplete("SUCCESS");
        setTimeout(() => {
          this.navigateAfterLogin();
        }, 3000);
      }
    }
  }

  backToCashier() {
    this.paymentProcessStep = 'step1';
    sessionStorage.removeItem('txnId')
    this.formReset()
  }

  formReset() {
    this.depositAmount =  this.predefineAmounts[1];
  }
 quickRegisterResponse;
  quickRegisterMode() {
    let userData = localStorage.getItem('registerUserData') ? JSON.parse(localStorage.getItem('registerUserData')) : null;
    let reqRequestData = this.getQuickRegisterRequestData(userData);
    if(this.quickRegisterResponse && this.quickRegisterResponse['status'] === 'SUCCESS'){
      this.firstDepositUserEvent(this.quickRegisterResponse)
    }else{
      this.pnpService.quickRegisterMode(reqRequestData, this.countryIP).then(data => {
        if (data['status'] === 'SUCCESS') {
          this.quickRegisterResponse = data;
          this.updateUserEventsAndTriggerThirdPartyLogin(data,userData,reqRequestData);
          this.firstDepositUserEvent(data)
        } else {
          this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.quickRegisterFailureMsg')
        }
  });
    }
    
    
  }

  getQuickRegisterRequestData(userData){
    this.quickRegistereCalled=true;
    let reqRequestData = {}
    
    if(environment.zimplerCountries.indexOf(this.countryIP)>=0 || environment.zimplerPnp.indexOf(this.countryIP)>=0){
      reqRequestData = {
        "txnId": this.transactionId,
        "emailId": localStorage.getItem("txnId") + '@'+environment.website_name+'.com',
        "password": Math.random().toString(36).slice(-8),
        "mobileIsdCode": '91',
        "mobileNumber": localStorage.getItem("txnId"),
      }
    }else{
      if(userData && userData.emailId){
        reqRequestData = {
          "txnId": this.transactionId,
          "emailId": userData.emailId,
          "password": userData.password,
          "mobileIsdCode": userData.areaCode,
          "mobileNumber": userData.phone,
        }
      }else if(this.isUserLoggedIn && this.userInfo){
          let password = localStorage.getItem("hashedPassword") ? localStorage.getItem("hashedPassword") : Math.random().toString(36).slice(-8);
          reqRequestData = {
            "txnId": this.transactionId,
            "emailId": this.userInfo.emailId,
            "password": password,
            "mobileIsdCode": this.userInfo.areaCode,
            "mobileNumber": this.userInfo.phone,
        }
      }else{
        this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong_redirection')
        return;
      }
    }
    reqRequestData = this.getAffiliateData(reqRequestData);
    if(!this.countryIP){
      this.countryIP = this.countryDataService.IPCountry
    } 
    reqRequestData = this.setUserLanguage(reqRequestData);
    return reqRequestData;
  }
  updateUserEventsAndTriggerThirdPartyLogin(data,userData,reqRequestData){
    this.registerUserEvents(data, userData, reqRequestData)
    this.getPNPThirdPartyLogin(this.transactionId, 'quick-registration','','',true);
    this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.deposit_success_msg', 'desposit');
  }
  setUserLanguage(reqRequestData){
    if(this.countryIP == 'FI'){
      reqRequestData['language'] = language['fi'];
    } else if(this.countryIP == 'SE'){
      reqRequestData['language'] = language['en'];
    } else if(this.countryIP == 'EE'){
      reqRequestData['language'] = language['et'];
    } else{
      reqRequestData['language'] = language[this.langCode];
    }
    return reqRequestData;
  }

  registerUserEvents(data, userData?, reqRequestData?){
    if(environment.zimplerCountries.indexOf(this.countryIP)>=0  || environment.zimplerPnp.indexOf(this.countryIP)>=0){
      this.fullPnpGtmEvent(data)
   }else{
      this.semiPnpGtmEvent(userData,data)
   }

   this.utils.S2Scalls(reqRequestData, "pnp");
   this.userDetailsService.setSemiPnpUserData(null)
  }
  firstDepositUserEvent(data){
    this.utils.depositGTMevent("userFirstDeposit", this.transactionId, data["externalEcrId"], parseInt(data['amount']), data['currency']);
  }
  fullPnpGtmEvent(data){
    this.utils.gtmEvent("userRegistered", {
      emailId: this.transactionId + '@'+environment.website_name+'.com',
      userExternalECR: data["ecrExternalID"],
      username: this.transactionId + '@'+environment.website_name+'.com'
    });
  }

  semiPnpGtmEvent(userData,data){
    if(userData && userData.emailId){
      this.utils.gtmEvent("userRegistered", {
        emailId: userData.emailId,
        userExternalECR: data["externalEcrId"],
        username: userData.emailId
      });
    }
  }

  getAffiliateData(reqRequestData) {
    if (this.utils.getAffliateId('affiliatename')) {
      reqRequestData['affiliateName'] = this.utils.getAffliateId('affiliatename');
    }
    if (this.utils.getAffliateId("affiliate")) {
      reqRequestData['affiliateId'] = this.utils.getAffliateId("affiliate");
    }
    if (this.utils.getAffliateId("tracker")) {
      reqRequestData['trackerId'] = this.utils.getAffliateId("tracker");
    }
    if (this.utils.getAffliateId("cvalue")) {
      reqRequestData['bannerId'] = this.utils.getAffliateId("cvalue");
    }
    return reqRequestData;
  }

  getPNPThirdPartyLogin(userTxnId, callingFrom, triggerS2Scall?, txnAmount?,isNewUser=false, transactionStatuData=null) {
    if (userTxnId) {
      let loginData = {
        "txnId": userTxnId
      }
      this.pnpService.getPNPThirdPartyLogin(loginData).then(loginResponse => {
        if (loginResponse && loginResponse["status"] === "SUCCESS") {
          if(isNewUser){
            this.polociesService.updatePolocies(true);
          }else{
            this.polociesService.checkPolociesInfo();
          }
          this.isLoadingBrite = false;
          if(loginResponse && loginResponse["externalEcrId"]){
            localStorage.setItem('newUserZimpler', loginResponse["externalEcrId"]);  
          }
         
          if((transactionStatuData && transactionStatuData['txnStatus'] == "LOGIN_WITHOUT_DEPOSIT" || transactionStatuData['txnStatus'] == "CASHIER_TRANSFER_SUCCESS" || transactionStatuData['txnStatus'] == "DEPOSIT_SUCCESS") || environment.zimplerCountries.indexOf(this.countryIP) == -1){
            this.pnpThirdPartyLoginSuccesHanlder(loginResponse, callingFrom);
          }
          localStorage.setItem("gtmLoggedInEvent", "thirdPartyLogin");
          this.emitterService.broadCastDepositeSuccess(true)
          this.emitterService.broadcastLoginStatus(true)
          this.emitterService.broadcastloginComplete('true')
          this.emitterService.broadcastLoadHomeBanner(callingFrom == "login" ? "userLoggedInn" : "User_Data_Updated" );
          if(callingFrom === 'deposit' && triggerS2Scall) {
            this.isToTriggerS2SForThirdPartyLogin = true;
            this.s2sTxnAmount = txnAmount;
          }
         
        } else {
          this.pnpThirdPartyLoginFailHanlder(loginResponse, callingFrom);
        }
      });
    }
  }

  pnpThirdPartyLoginSuccesHanlder(response, callingFrom) {
    let message = '';
    let key = ''
    switch (callingFrom) {
      case 'login':
        this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.loginSuccessMsg', callingFrom)
        break;
      case 'deposit':
        this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.depositSuccessMsg', callingFrom)
        break;
      case 'quick-registration':
        this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.loginSuccessMsg', callingFrom)
        break;
      default:
        this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.loginSuccessDefaultMsg', callingFrom)
    }
  }
  navigateAfterLogin() {
    this.closePNPModal();
    this.backToCashier();
    // this.router.navigate([this.langCode]);
  }

  applyMinMaxFromValidation(minLimit, maxLimit, callingFrom) {
    if(this.utils.isUserLoggedIn()){
      this.ajaxService.getProfileBalanceCurrency(true).pipe(takeUntil(this.destroy$)).subscribe(profileDetails => {
        this.withdrawalBalance = profileDetails["profile"]["balanceDetails"]["withdrawableBalance"]
        if(maxLimit > this.withdrawalBalance && this.callingFrom == 'withdraw'){
          maxLimit = this.withdrawalBalance;
        }
      });
    }
    
  }
  checkAmountIsValid(){
    if(typeof this.depositAmount=='string'){
      this.depositAmount = parseFloat(this.depositAmount);
    }
    if(!this.depositAmount || !(this.depositAmount >=1)){
      return false
    }
    return true
  }

  zimplerPNPInit(txnType = 'DEPOSIT') {
    if(this.isUserLoggedIn && this.userProfileDetails && this.userProfileDetails.externalEcrId){
      localStorage.setItem('newUserZimpler', this.userProfileDetails.externalEcrId);  
    }
    this.paymentProcessStep ='';
    this.isLoadingBrite = true;
    this.transactionType = txnType;
    this.clearIframeData();
    if (this.checkAmountIsValid() && txnType === 'DEPOSIT' || txnType === 'LOGIN') {
      
      /**If we have bonuscode we can pass below in the request object 
       * & property name is bonusCode
       * please add below line for redirection url before you deploy
       *   successURL:environment.siteUrl+'/redirection.html',
           failureURL:environment.siteUrl+'/redirection.html',
           redirectURL:environment.siteUrl+'/redirection.html'
       * */
           let selectedBonus = this.bonusService.getEligibleBonusCode();
           let langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en'
           if(!this.countryIP){
             this.countryIP = this.countryDataService.IPCountry
           }    
             // let zimplerLanguage = (environment.zimplerCountriesAvailableLanguages[countryIP].indexOf(this.langCode) >= 0) ? this.langCode : environment.zimplerDefaultLanguage;
             let initRequestData:any = {
             amount: txnType === 'DEPOSIT' ? this.depositAmount : 0,
             countryCode: this.countryIP,
             currencyCode: 'EUR',
             site: environment.site,
             siteDisplayName: environment.siteDisplayName,
             txnType: txnType,
            //  successURL: 'http://localhost:2265/redirection.html?transactionType=deposit',
            //  failureURL: 'http://localhost:2265/redirection.html?transactionType=deposit',
            //  redirectURL: 'http://localhost:2265/redirection.html?transactionType=deposit',
             redirectURL: window.location.origin + '/redirection.html?transactionType=deposit',
            successURL: window.location.origin + '/redirection.html?transactionType=deposit',
             failureURL: window.location.origin + '/redirection.html?transactionType=deposit',
            //  redirectURL: window.location.origin + '/redirection.html?transactionType=deposit',
             bonusCode: selectedBonus && selectedBonus['bonusCode'] ? selectedBonus['bonusCode'] : ''
           }
           //if(this.countryIP == 'EE'){
             initRequestData.language = langCode;
             initRequestData.osBrowserType = this.utils.getOsBrowserType();
             initRequestData.channelId = this.windowType == 'device' ? 'Web' : 'Mobile';
             initRequestData.subChannel = this.windowType == 'mobile' ? 'native' : 'HTML';
           //}else 

           if(this.isSemiPnp && this.isUserLoggedIn){
              // // Data when clicked on Direct Login form
              // let password = localStorage.getItem("hashedPassword") ? localStorage.getItem("hashedPassword") : Math.random().toString(36).slice(-8);
              // // Data when came in from PNP deposit/login form 
              // let userData = localStorage.getItem('registerUserData') ? JSON.parse(localStorage.getItem('registerUserData')) : null;
              // if(userData && userData.password){
              //   password = userData.password;
              // }
              // let
              // initRequestData.emailId = this.userProfileDetails.email?this.userProfileDetails.email:"";
              // initRequestData.passwordHash = password;
              let userData = localStorage.getItem('registerUserData') ? JSON.parse(localStorage.getItem('registerUserData')) : null;
              let reqRequestData:any = this.getQuickRegisterRequestData(userData);
              initRequestData.emailId = reqRequestData.emailId;
              initRequestData.passwordHash = reqRequestData.password;
           }

           if(this.countryIP== 'FI'){
             initRequestData.locale = 'fi';
           }else if(this.countryIP== 'SE'){
             initRequestData.locale = 'en';
           }
           initRequestData = this.setUserLanguage(initRequestData);
           initRequestData = this.getAffiliateData(initRequestData);
           initRequestData.emailAndMobileSubscribed = true;
           this.pnpService.depositPayAndPlayInit(initRequestData,this.countryIP).then(data => {
             if (data["status"] === "SUCCESS" && (data["redirectURL"])) {
               this.isLoadingBrite = false;
               localStorage.setItem("txnId", data["txnId"]);
                 this.paymentProcessStep = 'step2';
                 let self = this;
                 if ($(".zimplerIframeContainer")) {
                  $(".zimplerIframeContainer").empty();
                }
                 if(this.windowType == 'mobile' && (environment.semiPnpZimplerCountries.indexOf(this.countryIP)>=0 || environment.zimplerPnp.indexOf(this.countryIP)>=0)){
                   let a= document.createElement('a');
                  a.href= data["redirectURL"];
                  a.click();
                 }else{
                  setTimeout(() => {
                    self.paymentProcessStep = 'step2';
                    let $iframe = $('<iframe src="' + data["redirectURL"] + '" ></iframe>');
                    $(".zimplerIframeWinodow").append($iframe)
                  });
                 }
             }
             else if (data["status"] === "SUCCESS" && data["signature"]) {
               localStorage.setItem("txnId", data["txnId"]);
                 this.paymentProcessStep = 'step2';
                 this.loadScript('https://websdk.britepayments.io/v1/client.js', data["signature"]);
             } else {
              this.isLoadingBrite = false;
               this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong_redirection')
             }
           });
         }
  }


  /** withdraw code here */
  updateWithdrawLimits(){
    this.getCashoutTxnLimits(true);
    //todo
    // let withdrawLimits=this.pnpService.cashOutLimits;
    // if(withdrawLimits['minLimit'] && withdrawLimits['maxLimit']){
    //   this.applyMinMaxFromValidation(withdrawLimits['minLimit'],withdrawLimits['maxLimit'],'withdraw');
    // }else{
    //   this.getCashoutTxnLimits(true);
    // }
  }

  getCashoutTxnLimits(isapplyValidation=false) {
    let userCountry = this.userDetailsService.userProfileDetails.country ? this.userDetailsService.userProfileDetails.country : this.userDetailsService.userProfileDetails.countryCode;
    this.pnpService.getCashoutTxnLimits('withdrawal', userCountry)
      .pipe(takeUntil(this.destroy$)).subscribe(cashOutData => {
        if(cashOutData && cashOutData['minLimit'] && cashOutData['maxLimit']){
          if(isapplyValidation){
            this.applyMinMaxFromValidation(cashOutData['minLimit'],cashOutData['maxLimit'],'withdraw');
          }
        }
      });
  }

  zimplerPNPWithDrawInit(txnType = 'WITHDRAW'){
    this.clearIframeData();
    this.isButtonLoader = true;
    if(this.checkAmountIsValid() && txnType === 'WITHDRAW'){
      let withdrawRequestData={
        depositAmount:this.depositAmount,
        paymentMethod: this.isPnpFlow ? "BritePlay": "ZIMPLER_DIRECT",
        comments:'system',
        site: environment.site,
       }
       this.pnpService.
       zimplerWithdrawInit(withdrawRequestData).pipe(takeUntil(this.destroy$)).subscribe(data=>{
        /** for future reference, if any redirection url is given */
        /**for deposit redirection urls are coming from CMS,
         * where as for withdraw redirection url is from php code level which
         * is hard coded on php side 
         * just adding here for reference 
         * whether success or failure use will be naviagted to below url
         * which we are handing from app router only widthdraw due some 
         * dependance from php side
         *cashier/callback/ZIMPLER_DIRECT/ctctrvctrctrtvctrctrctctctc?paymentType=cashout
         */

        // if(data['status'] === "SUCCESS" && data["redirectURL"]){
        //   sessionStorage.setItem("txnId",data["txnId"]);
        //   if(this.windowType === 'mobile'){
        //     window.open(data["redirectURL"],"_self");
        //   }else{
        //     this.paymentProcessStep= 'step2';
        //     setTimeout(() => {
        //       let $iframe = $('<iframe src="' + data["redirectURL"] + '" ></iframe>');
        //       $(".zimplerIframeContainer").append($iframe)
        //     });
        //   }
        // }else 
        this.isButtonLoader = false
        if(data['status'] === "SUCCESS"){
          // this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.withdrawSuccessWaitingApproval')
          this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "close" });
          this.emitterService.broadcastModalState({ name: "pendingwithdrawl", state: "open" });
          this.emitterService.broadcasttxnComplete("SUCCESS");
                setTimeout(()=>{
                    this.emitterService.broadCastWithdrwalSuccessMsg(true);
                })
        }else{
          this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.something_went_wrong_redirection')
        }
       });
  }
  }

  getWithdrawTransactionStatus() {
    if (sessionStorage.getItem('txnId')) {
      const data = {
        txnId: sessionStorage.getItem('txnId'),
        type: "CASHOUT"
      }
      this.pnpService.getUserPSPTranstionStatus(data)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response && response['status'] === "SUCCESS") {
          this.withdrawTnxSuccessHandler(response);
        }else{
          this.withdrawTnxFailureHandler(response);
        }
      })
    }
  }

  withdrawTnxSuccessHandler(data){
    let message='';
    if(data['actualStatusInDB'] === 'co_initiated'){
      this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.withdrawSuccessWaitingApproval')
    }else{
      this.actionOnTransactionRedirection(txnState.SUCCESS_MESSAGE, 'zimpler.withdrawSuccess')
    }
  }

  withdrawTnxFailureHandler(data){
    this.actionOnTransactionRedirection(txnState.FAILURE_MESSAGE, 'zimpler.withdrawRequestfailed')
  }

  clearIframeData() {
    if ($(".zimplerIframeContainer")) {
      $(".zimplerIframeContainer").empty();
    }
    this.transactionErrorMessage = '';
    this.transactionSuccessMessage = '';
  }

  isButtonDisabled(formName) {
    return this.utils.isButtonDisabled(formName)
  }

  closePNPModal() {
    this.cancellBriteFrame = true;
    this.clearIframeData()
    this.emitterService.broadcastModalState({ name: "pnpDepositModal", state: "close" });
    this.resetBroadCastLoginDepositNull()
    // if(this.isUserLoggedIn) this.bonusService.broadRefreshEligibleBonus(true); //removing the bonus code details if it is set earlier
    if(this.bonusService.getEligibleBonusCode()) this.bonusService.setEligibleBonusCode(null);
  }

  resetBroadCastLoginDepositNull() {
    this.pnpService.broadCastInitiateDeposit(null);
    this.pnpService.broadCastInitiateLogin(null);
    this.pnpService.broadCastInitiateWithDraw(null)
    this.pnpService.broadCastInitQuickDeposit(null);
  }

  moveToTrustlyLogin(){ 
    this.pnpService.openZimplerLogin()
  }
  public loadScript(url,signature) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    let self = this;
    
    node.onload = (res) => {
      if(self.cancellBriteFrame){
        return;
      }   
      let interval = setInterval(() => {
          if($('#briteplayIframeContainer iframe') && $('#briteplayIframeContainer iframe').length){
           setTimeout(()=>{
            self.isLoadingBrite = false;
            clearInterval(interval);
           },1000)
           }
        }, 500);
      let briteObject = window['Brite'];
      let client = new briteObject(signature);
      client.start({
        selector: '#briteplayIframeContainer',
        style: {    
          background_color: "#aaaaff",    
          text_strong_color: "#335970",    
          text_weak_color: "#225560",    
          primary_color: "000000",    
          button_text_color: "#335970",    
          font_family: "Verdana",    
          selected_color: "#335970"
          }
          }, function(state) {
          if(state == briteObject.STATE_AUTHENTICATION_STARTED){
              console.log("AUTHENTICATION_STARTED");
          }
          if(state == briteObject.STATE_TRANSACTION_APPROVAL_STARTED){
              console.log("STATE_TRANSACTION_APPROVAL_STARTED");
          }
          if (state == briteObject.STATE_COMPLETED) {
            self.paymentProcessStep = 'step3';
            self.getPNPUserFromTransaction();
            console.log("client completed");
          }
        }, function() {
          if(  self.paymentProcessStep == "step2"){
            self.paymentProcessStep = "step1";  
          }
          self.clearIframeData();    
          self.callingFrom = "deposit"
          console.log("client closed");
          client.stop();
        });
      }
}
getValueForTab(value){
  value = value * this.multipleValue
  if(this.isUserLoggedIn){
    return this.userDetailsService.getUserFormatedBalence(value, true)
  }
  return this.currencySymbol+" "+value
}
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.resetBroadCastLoginDepositNull();
    if(this.bonusService.getEligibleBonusCode()) this.bonusService.setEligibleBonusCode(null);
  }
}
